export default "__VITE_ASSET__BvHRLjeu__"